// Design tokens extraits de Landing v2 (frontend/src/pages/Landing.js — landingCss).
// Source de vérité pour les couleurs, typographie, espacements, radii et shadows
// utilisés dans toutes les pages refondues (Login, Register, etc.).
//
// Usage :
//   import { tokens } from '../styles/design-tokens';
//   const styles = { page: { background: tokens.colors.sand, color: tokens.colors.ink } };

export const tokens = {
  colors: {
    // Marque Revyo
    brand: '#E8502A',
    brandHover: '#CC4220',
    brandLight: '#FCEEE8',
    brandMid: '#F0B49A',

    // Fonds beige/sable — signature visuelle landing v2
    sand: '#EDEAE3',
    sand2: '#F5F2EC',
    sand3: '#F6F4EF',
    sand4: '#E5E2DB',
    sandBorder: '#EAE7DE',

    // Typographie
    ink: '#1A1A1A',
    inkDeep: '#1A1710',
    gray1: '#6B6B6B',
    gray2: '#6E6C62',
    gray3: '#AEACA4',

    // Sémantique
    green: '#0A7A45',
    greenLight: '#E4F5EC',
    red: '#CC3333',
    redLight: '#FFF5F5',
    redBorder: '#FDD6D6',
    gold: '#F59E0B',
    googleBlue: '#4285F4',

    // Formulaires — erreur douce alignée avec la mission P1.6
    errorBg: '#FFEBEE',
    errorText: '#D32F2F',

    // Surfaces
    white: '#FFFFFF',
    black: '#000000'
  },

  fonts: {
    sans: "'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    heading: "'Sora', 'Inter', system-ui, sans-serif",
    mono: "'JetBrains Mono', ui-monospace, monospace"
  },

  fontSize: {
    xs: '12px',
    sm: '13px',
    base: '14px',
    md: '15px',
    lg: '17px',
    xl: '20px',
    '2xl': '24px',
    '3xl': '32px',
    '4xl': '42px'
  },

  fontWeight: {
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    black: 800
  },

  spacing: {
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '24px',
    '2xl': '32px',
    '3xl': '48px',
    '4xl': '64px'
  },

  radii: {
    sm: '8px',
    md: '10px',
    lg: '14px',
    xl: '18px',
    pill: '999px'
  },

  shadows: {
    card: '0 2px 12px rgba(0,0,0,0.04)',
    cardHover: '0 8px 28px rgba(0,0,0,0.08)',
    modal: '0 20px 60px rgba(0,0,0,0.25)',
    cta: '0 4px 14px rgba(232,80,42,0.22)',
    ctaHover: '0 8px 20px rgba(232,80,42,0.28)'
  },

  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
    wide: '1240px'
  }
};

export default tokens;
